import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { UiInputIncrementorComponent } from './components/input-incrementor/input-incrementor.component';
import { CoreFeaturesMultipleStackPriceModule } from '@brunsker/libs/core/features/multiple-stack-price/src';
import { CoreFeaturesMouseHoldModule } from '@brunsker/libs/core/features/mouse-hold/src';

@NgModule({
  declarations: [UiInputIncrementorComponent],
  exports: [UiInputIncrementorComponent],
  imports: [
    CommonModule,
    CoreFeaturesMultipleStackPriceModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CoreFeaturesMouseHoldModule,
    NgxMaskDirective
  ],
  providers: [provideNgxMask()]
})
export class CoreUiInputIncrementorModule {}
